import MarkdownIt from 'markdown-it';
import {Fragment, Slice} from "prosemirror-model";
import {CARD_MAX_PASTE_SIZE} from "@/Const";
import RightMenu from "@/components/RightMenu";
import {insertCopyLinkToCard, insertDeeplinkToCard, isSupportLink} from "@/Utility";
import {
    extFromMineType,
    generateUUID2,
    isCardBlockDeeplink,
    isDeepLink,
    isTranscriptDeeplink,
    isUrl,
    removeHtmlTags
} from "@/utils";
import { NodeSelection } from 'prosemirror-state';
import {imgServer} from "@/components/EditorV2/imgServer";
import { ReplaceStep } from 'prosemirror-transform';
import { t } from 'i18next';

export function getTiptapHandleText(text){
    if (isDeepLink(text))return text;

    const match = text.match(/<!--StartFragment-->([\s\S]*?)<!--EndFragment-->/);
    const plainText = match ? match[1].trim() : text;

    let szText = plainText;
    try {
        let slice = handleClipboard(window.publicEditor,szText);
        const { state, view } = window.publicEditor;
        // 创建 ReplaceStep（替换选区内容为 Slice）
        // 获取当前选区范围
        const { from, to } = state.selection;
        const step = new ReplaceStep(from, to, slice);
        // 应用事务
        const tr = state.tr.step(step);
        view.dispatch(tr);
        szText = window.publicEditor.getHTML();
    }catch (e){

    }
    window.publicEditor.commands.setContent('');
    return szText;
}

/**
 * 处理剪切板事件。。。
 * @param editor
 * @param text
 */
export function handleClipboard(editor:any,text:any){
    // 解析节点内容
    const md = new MarkdownIt();
    md.core.ruler.before('block', 'single_line_breaks', (state) => {
        // 保护代码块内容，避免替换代码块内的空行
        const codeBlocks: string[] = [];
        // 匹配代码块（``` 或 ~~~）
        let protectedSrc = state.src.replace(
            /(^|\n)(```|~~~)([\s\S]*?)\2/g,
            (match) => {
                const placeholder = `__CODE_BLOCK_${codeBlocks.length}__`;
                codeBlocks.push(match);
                return placeholder;
            }
        );
        // 对非代码块部分进行空行替换
        protectedSrc = protectedSrc.replace(
            /\n{2,}/g,
            (match) => "\n" + "# <br>\n".repeat(match.length - 1)
        );
        // 恢复代码块内容
        codeBlocks.forEach((block, index) => {
            protectedSrc = protectedSrc.replace(`__CODE_BLOCK_${index}__`, block);
        });
        state.src = protectedSrc;
    });
    md.core.ruler.before('block', 'prevent_link_def', (state) => {
        // 拦截并保留脚注样式定义的行
        state.src = state.src.replace(/\[timestamp\]:([\d:]+)/g, (match) => match.replace(':', '\\:'));
    });
    md.block.ruler.disable(["lheading"]); // 禁用Setext风格标题
    md.block.ruler.disable('code');
    const parsed = md.parse(removeSingleBlankLines(text), {});
    let schema = editor.schema  // 你的 schema 对象，包含定义的节点和 mark 类型
    // 解析节点内容
    function removeSingleBlankLines(mdText: string) {
        // 去掉list之间的空行
        let output = mdText;
        let previousOutput;
        const getIndentLen = (line: string) =>
            (String(line).match(/^([\t ]*)/)?.[1] || "").length;

        do {
            previousOutput = output;
            output = output
                .replace(
                    /([\t ]{0,20}[0-9]+\.\s.*?(\r\n|\n))([\t ]{0,20}((\r\n|\n){1}))([\t ]{0,20}[0-9]+\.\s.*(\r\n|\n))/g,
                    "$1$6"
                )
                .replace(
                    /([\t ]{0,20}-\s(?!\[[ xX]\]\s).*?(\r\n|\n))([\t ]{0,20}((\r\n|\n){1}))([\t ]{0,20}-\s(?!\[[ xX]\]\s).*(\r\n|\n))/g,
                    "$1$6"
                )
                .replace(
                    /([\t ]{0,20}- \[([ xX])\] .*?(\r\n|\n))([\t ]{0,20}((\r\n|\n){1}))([\t ]{0,20}- \[([ xX])\] .*(\r\n|\n))/g,
                    "$1$7"
                )
                .replace(
                    /(^[\t ]{0,20}[0-9]+\.\s.*?(?:\r\n|\n))([\t ]{0,20}(?:\r\n|\n))(^[\t ]{0,20}-\s(?!\[[ xX]\]\s).*?(?:\r\n|\n))/gm,
                    (match, a, blank, b) =>
                        getIndentLen(b) > getIndentLen(a) ? a + b : match
                )
                .replace(
                    /(^[\t ]{0,20}-\s(?!\[[ xX]\]\s).*?(?:\r\n|\n))([\t ]{0,20}(?:\r\n|\n))(^[\t ]{0,20}[0-9]+\.\s.*?(?:\r\n|\n))/gm,
                    (match, a, blank, b) =>
                        getIndentLen(b) > getIndentLen(a) ? a + b : match
                )
                .replace(
                    /(^[\t ]{0,20}[0-9]+\.\s.*?(?:\r\n|\n))([\t ]{0,20}(?:\r\n|\n))(^[\t ]{0,20}- \[[ xX]\] .*?(?:\r\n|\n))/gm,
                    (match, a, blank, b) =>
                        getIndentLen(b) > getIndentLen(a) ? a + b : match
                )
                .replace(
                    /(^[\t ]{0,20}- \[[ xX]\] .*?(?:\r\n|\n))([\t ]{0,20}(?:\r\n|\n))(^[\t ]{0,20}[0-9]+\.\s.*?(?:\r\n|\n))/gm,
                    (match, a, blank, b) =>
                        getIndentLen(b) > getIndentLen(a) ? a + b : match
                )
                .replace(
                    /(^[\t ]{0,20}-\s(?!\[[ xX]\]\s).*?(?:\r\n|\n))([\t ]{0,20}(?:\r\n|\n))(^[\t ]{0,20}- \[[ xX]\] .*?(?:\r\n|\n))/gm,
                    (match, a, blank, b) =>
                        getIndentLen(b) > getIndentLen(a) ? a + b : match
                )
                .replace(
                    /(^[\t ]{0,20}- \[[ xX]\] .*?(?:\r\n|\n))([\t ]{0,20}(?:\r\n|\n))(^[\t ]{0,20}-\s(?!\[[ xX]\]\s).*?(?:\r\n|\n))/gm,
                    (match, a, blank, b) =>
                        getIndentLen(b) > getIndentLen(a) ? a + b : match
                )
        } while (output !== previousOutput);

        // 按行扫描：去除列表区块内部的空行（处理列表内容行与下一个列表项之间的空行）
        {
            const lines = output.split(/\n/);
            const result: string[] = [];
            // 判断是否为列表标记行（有序、无序、task）
            const isListMarker = (line: string) =>
                /^[\t ]*(\d+\.\s|- \[[ xX]\] |[-*+]\s)/.test(line);
            // 判断是否为列表内容的延续行（有缩进的非空行）
            const isIndentedContent = (line: string) =>
                /^[\t ]+\S/.test(line);
            // 判断一行是否属于列表上下文
            const isListContext = (line: string) =>
                isListMarker(line) || isIndentedContent(line);

            let i = 0;
            while (i < lines.length) {
                const line = lines[i];
                // 当遇到空行时，检查前后是否都在列表上下文中
                if (line.trim() === '') {
                    // 收集连续的空行
                    let blankCount = 0;
                    let j = i;
                    while (j < lines.length && lines[j].trim() === '') {
                        blankCount++;
                        j++;
                    }
                    // 检查空行前面的最后一个非空行和后面的第一个非空行
                    const prevNonEmpty = result.length > 0 ? result[result.length - 1] : '';
                    const nextNonEmpty = j < lines.length ? lines[j] : '';
                    if (
                        prevNonEmpty &&
                        nextNonEmpty &&
                        isListContext(prevNonEmpty) &&
                        (isListMarker(nextNonEmpty) || isIndentedContent(nextNonEmpty))
                    ) {
                        // 在列表上下文中，跳过空行
                        i = j;
                    } else {
                        // 不在列表上下文中，保留空行
                        for (let k = 0; k < blankCount; k++) {
                            result.push('');
                        }
                        i = j;
                    }
                } else {
                    result.push(line);
                    i++;
                }
            }
            output = result.join('\n');
        }

        const filterText = output
            .replace(/<a\s+href="([^"]+)"[^>]*>(.*?)<\/a>/g, '\n[$2]($1)\n') // 将a标签替换为链接的标准形式
        return filterText
    }
    function removeLastUnderscoreSuffix(str: string) {
        const index = str.lastIndexOf('_');
        return index !== -1 ? str.slice(0, index) : str;
    }

    function findFirstListTag(tokens: any[]) {
        const firstEleIndex = tokens.findIndex(token =>
            token.type === 'bullet_list_open' || token.type === 'ordered_list_open'
        );
        return {
            index: firstEleIndex,
            ele: tokens[firstEleIndex]?.type.replace('_open', '')
        }
    }
    // 检查token数组中第1个元素是否闭合
    function checkFirstTagClose(tokens: any[]) {
        const firstListTag = findFirstListTag(tokens);
        return countCharacterInArray(`${firstListTag?.ele}_open`, tokens) === countCharacterInArray(`${firstListTag?.ele}_close`, tokens)
    }
    function processEmptyParagraphs(arr) {
        let consecutiveEmptyCount = 0;  // 记录连续空行数量
        const result = [];  // 结果数组，用于存放处理后的数据
        const emptyParagraphs = [];  // 用于临时存放空行的索引

        for (let i = 0; i < arr.length; i++) {
            const item = arr[i];

            // 检查当前项是否为空行 (type为paragraph且content为空)
            if (item.type.name === "paragraph" && item?.content?.size === 0) {
                emptyParagraphs.push(i);  // 将空行的索引添加到临时数组
                consecutiveEmptyCount++;  // 增加空行计数
            } else {
                // 处理空行，连续空行的数量大于2时，做删除处理
                if (consecutiveEmptyCount > 0) {
                    if (consecutiveEmptyCount <= 2) {
                        // 如果连续空行小于等于2，直接删除
                        for (let j = 0; j < emptyParagraphs.length; j++) {
                            result.splice(emptyParagraphs[j] - j, 1);  // 删除空行
                        }
                    } else {
                        // 如果连续空行大于2，减去2然后向上取整
                        const toDelete = Math.ceil((consecutiveEmptyCount - 2) / 2);
                        for (let j = 0; j < toDelete; j++) {
                            result.splice(emptyParagraphs[j] - j, 1);  // 删除多余的空行
                        }
                    }
                    consecutiveEmptyCount = 0;  // 重置连续空行计数
                    emptyParagraphs.length = 0;  // 清空临时存放空行索引的数组
                }
                result.push(item);  // 非空行，直接加入结果
            }
        }

        // 如果最后有空行需要删除，也要处理
        if (consecutiveEmptyCount > 0) {
            if (consecutiveEmptyCount <= 2) {
                for (let j = 0; j < emptyParagraphs.length; j++) {
                    result.splice(emptyParagraphs[j] - j, 1);  // 删除空行
                }
            } else {
                const toDelete = Math.ceil((consecutiveEmptyCount - 2) / 2);
                for (let j = 0; j < toDelete; j++) {
                    result.splice(emptyParagraphs[j] - j, 1);  // 删除多余的空行
                }
            }
        }

        return result;
    }

    //mark样式处理
    function markControl(markStr: string) {
        // 针对obsidian中的规则：特殊符号前加\符号进行处理  如果后面紧跟这些符号内容就替换掉
        markStr = markStr.replace(/\\([*_~`[\](){}#+-.])/g, "$1");

        // 匹配 Markdown 的样式规则（按优先级从长到短排列）
        // 只使用 ** 代表粗体，* 代表斜体
        // 混合样式组合：***~~text~~*** (粗斜体+删除线), ~~***text***~~ 等
        // 链接格式：1. [text](url)  2. https://example.com  3. domain.com/path
        // 下划线格式：<u>text</u>
        // 换行符：\n
        const regex =
            /(~~\*\*\*.*?\*\*\*~~|\*\*\*~~.*?~~\*\*\*|~~\*\*.*?\*\*~~|\*\*~~.*?~~\*\*|~~\*.*?\*~~|\*~~.*?~~\*|\*\*\*.*?\*\*\*|\*\*.*?\*\*|~~.*?~~|\*.*?\*|`.*?`|<u>(.*?)<\/u>|\[([^\]]+)\]\(([^)]+)\)|https?:\/\/[^\s<>\[\]"']+|(?<![a-zA-Z0-9@])(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+(?:com|net|org|edu|gov|mil|co|io|app|dev|cn|uk|de|fr|jp|ru|br|in|au|info|biz|me|tv|cc|xyz|site|online|tech|store|blog|cloud|ai)(?:\/[^\s<>\[\]"']*)?|\n)/g;
        // 初始化结果数组
        const result = [];

        // 定义样式映射（按前缀长度从长到短排列，确保优先匹配更长的前缀）
        // 只使用 ** 代表粗体，* 代表斜体（去掉 __ 和 _ 格式）
        const styles: { [key: string]: string[] } = {
            // 三重混合：粗斜体 + 删除线
            "~~***": ["strike", "bold", "italic"], // ~~***text***~~
            "***~~": ["bold", "italic", "strike"], // ***~~text~~***
            // 双重混合：粗体 + 删除线
            "~~**": ["strike", "bold"], // ~~**text**~~
            "**~~": ["bold", "strike"], // **~~text~~**
            // 双重混合：斜体 + 删除线
            "~~*": ["strike", "italic"], // ~~*text*~~
            "*~~": ["italic", "strike"], // *~~text~~*
            // 粗斜体组合
            "***": ["bold", "italic"], // ***text***
            // 单一样式
            "**": ["bold"], // **text**
            "~~": ["strike"], // ~~text~~
            "*": ["italic"], // *text*
            "`": ["code"], // `code`
        };

        // 前缀列表（按长度从长到短排序，用于匹配）
        const prefixList = Object.keys(styles).sort(
            (a, b) => b.length - a.length
        );

        // 解析输入
        let match;
        let lastIndex = 0;
        while ((match = regex.exec(markStr)) !== null) {
            const matchedText = match[0];

            // 如果匹配之前有普通文本，先加入普通文本部分
            if (match.index > lastIndex) {
                result.push(schema.text(markStr.slice(lastIndex, match.index)));
            }

            // 检查是否是换行符
            if (matchedText === "\n") {
                // 插入硬换行节点 (hardBreak)
                result.push(schema.nodes.hardBreak.create());
            }
            // 检查是否是下划线格式 <u>text</u>
            else if (
                match[2] !== undefined &&
                matchedText.startsWith("<u>")
            ) {
                const underlineText = match[2];
                const underlineMark = schema.marks.underline.create();
                const underlineNode = schema
                    .text(underlineText)
                    .mark([underlineMark]);
                result.push(underlineNode);
            }
            // 检查是否是 Markdown 链接格式 [text](url)
            else if (match[3] !== undefined && match[4] !== undefined) {
                const linkText = match[3];
                const linkUrl = match[4];
                const linkMark = schema.marks.link.create({ href: linkUrl });
                const linkNode = schema.text(linkText).mark([linkMark]);
                result.push(linkNode);
            }
            // 检查是否是带 http/https 的 URL 或裸域名 URL
            else if (
                matchedText.match(/^https?:\/\//) ||
                matchedText.match(
                    /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+(?:com|net|org|edu|gov|mil|co|io|app|dev|cn|uk|de|fr|jp|ru|br|in|au|info|biz|me|tv|cc|xyz|site|online|tech|store|blog|cloud|ai)/
                )
            ) {
                // 如果是裸域名，自动添加 https://
                const linkUrl = matchedText.startsWith("http")
                    ? matchedText
                    : `https://${matchedText}`;
                const linkMark = schema.marks.link.create({ href: linkUrl });
                const linkNode = schema.text(matchedText).mark([linkMark]);
                result.push(linkNode);
            } else {
                // 获取样式前缀（动态判断，优先匹配长的）
                let prefix = "";
                for (const p of prefixList) {
                    if (matchedText.startsWith(p)) {
                        prefix = p;
                        break;
                    }
                }

                if (prefix && styles[prefix]) {
                    // 计算后缀（处理不对称的情况）
                    let suffix = prefix;
                    // 特殊处理不对称前后缀
                    if (prefix === "~~***") suffix = "***~~";
                    else if (prefix === "***~~") suffix = "~~***";
                    else if (prefix === "~~**") suffix = "**~~";
                    else if (prefix === "**~~") suffix = "~~**";
                    else if (prefix === "~~*") suffix = "*~~";
                    else if (prefix === "*~~") suffix = "~~*";

                    // 去掉前缀和后缀，提取内容
                    let content = matchedText.slice(
                        prefix.length,
                        -suffix.length
                    );

                    // 添加匹配到的样式文本
                    const markTypes = styles[prefix];
                    const marks = markTypes.map((markType) =>
                        schema.marks[markType].create()
                    );
                    if (content && content.length > 0) {
                        result.push(schema.text(content).mark(marks));
                    }
                } else {
                    // 无法识别的格式，作为普通文本处理
                    result.push(schema.text(matchedText));
                }
            }

            // 更新 lastIndex
            lastIndex = regex.lastIndex;
        }
        // 如果匹配结束后还有普通文本，加入结果数组
        if (lastIndex < markStr.length) {
            result.push(schema.text(markStr.slice(lastIndex)));
        }
        return result;
    }
    // 专门处理最外层bulletlist
    function numberListItemDeal1(nestArr: any[]) {
        let bulletList;
        let listArr: any[] = [];
        let listItemArr: any[] = [];
        let startCompute = false;
        for (let i = 0; i < nestArr.length; i++) {
            if (
                nestArr[i].type === "list_item_open" &&
                listItemArr.length === 0
            ) {
                startCompute = true;
                listItemArr.push(nestArr[i]);
            } else if (
                nestArr[i].type === "list_item_close" &&
                computeFinal("list_item", nestArr.slice(0, i + 1))
            ) {
                listItemArr.push(nestArr[i]);
                listArr.push({
                    type: "listItem",
                    content:
                        numberListItemDeal2(listItemArr).length === 0
                            ? [
                                {
                                    type: "paragraph",
                                    content: [{ type: "text", text: " " }],
                                },
                            ]
                            : numberListItemDeal2(listItemArr), // 空list处理
                });
                listItemArr = [];
                startCompute = false;
            } else if (startCompute) {
                listItemArr.push(nestArr[i]);
            }
        }
        bulletList = {
            type: "orderedList",
            content: listArr,
        };
        return bulletList;
    }

    // 专门处理最外层list-item 需要注意的是这个时候listitem里面可能只有最基本的item结构，也有可能嵌套着list
    function numberListItemDeal2(nestArr: any[]) {
        let listArr = [];
        let listItemArr: any[] = [];
        let insideBulletList = false;
        let insideNumberList = false;
        for (let i = 0; i < nestArr.length; i++) {
            if (nestArr[i].type === "ordered_list_open") {
                listItemArr.push(nestArr[i]);
                insideNumberList = true;
            } else if (
                nestArr[i].type === "ordered_list_close" &&
                countCharacterInArray(
                    `ordered_list_open`,
                    nestArr.slice(0, i + 1)
                ) ===
                countCharacterInArray(
                    `ordered_list_close`,
                    nestArr.slice(0, i + 1)
                ) &&
                checkFirstTagClose(nestArr.slice(0, i + 1))
            ) {
                listItemArr.push(nestArr[i]);
                insideNumberList = false;
                // 如果 listArr 为空，先添加一个空的 paragraph
                // 因为 listItem 的第一个子节点必须是 paragraph
                if (listArr.length === 0) {
                    listArr.push({
                        type: "paragraph",
                        content: [{ type: "text", text: " " }],
                    });
                }
                listArr.push(numberListItemDeal1(listItemArr));
                listItemArr = [];
            } else if (nestArr[i].type === "bullet_list_open") {
                listItemArr.push(nestArr[i]);
                insideBulletList = true;
            } else if (
                nestArr[i].type === "bullet_list_close" &&
                countCharacterInArray(
                    `bullet_list_open`,
                    nestArr.slice(0, i + 1)
                ) ===
                countCharacterInArray(
                    `bullet_list_close`,
                    nestArr.slice(0, i + 1)
                ) &&
                checkFirstTagClose(nestArr.slice(0, i + 1))
            ) {
                listItemArr.push(nestArr[i]);
                insideBulletList = false;
                // 如果 listArr 为空，先添加一个空的 paragraph
                // 因为 listItem 的第一个子节点必须是 paragraph
                if (listArr.length === 0) {
                    listArr.push({
                        type: "paragraph",
                        content: [{ type: "text", text: " " }],
                    });
                }
                listArr.push(bulletListItemDeal1(listItemArr));
                listItemArr = [];
            } else if (insideNumberList || insideBulletList) {
                listItemArr.push(nestArr[i]);
            } else if (
                nestArr[i].type === "inline" &&
                !insideNumberList &&
                !insideBulletList
            ) {
                listArr.push({
                    type: "paragraph",
                    // content: [{ type: "text", text: nestArr[i].content.replace(/\\([*_~`[\](){}#+-.])/g, '$1') }],
                    content: markControl(nestArr[i].content).map((node) =>
                        node.toJSON()
                    ),
                });
            } else if (
                nestArr[i].type === "fence" &&
                !insideNumberList &&
                !insideBulletList
            ) {
                // 处理list_item内部的代码块
                listArr.push({
                    type: "codeBlock",
                    content: [
                        {
                            type: "text",
                            text:
                                nestArr[i].content === ""
                                    ? " "
                                    : nestArr[i].content,
                        },
                    ],
                });
            }
        }
        return listArr;
    }

    // list结构处理
    function numberListDeal(nestArr: any[]) {
        return editor.schema.nodeFromJSON(numberListItemDeal1(nestArr));
    }
    // 一部分tasklist会被识别为bulletlist
    function bulletListDeal(nestArr: any[]) {
        return editor.schema.nodeFromJSON(bulletListDealJson(nestArr));
    }


    // 专门处理最外层bulletlist
    function bulletListItemDeal1(nestArr: any[]) {
        let bulletList;
        let listArr: any[] = [];
        let listItemArr: any[] = [];
        let startCompute = false;
        let ifBullet = true;
        let firstItem = true;
        for (let i = 0; i < nestArr.length; i++) {
            if (
                nestArr[i].type === "list_item_open" &&
                listItemArr.length === 0
            ) {
                startCompute = true;
                listItemArr.push(nestArr[i]);
            } else if (
                nestArr[i].type === "list_item_close" &&
                computeFinal("list_item", nestArr.slice(0, i + 1))
            ) {
                listItemArr.push(nestArr[i]);
                // 尝试进行listitem类型矫正  目前不支持同级混合list结构  以item0为准
                if (firstItem === true) {
                    ifBullet = bulletListItemDetect2(listItemArr);
                    firstItem = false;
                }
                if (ifBullet) {
                    listArr.push({
                        type: "listItem",
                        content:
                            bulletListItemDeal2(listItemArr).length === 0
                                ? [
                                    {
                                        type: "paragraph",
                                        content: [{ type: "text", text: " " }],
                                    },
                                ]
                                : bulletListItemDeal2(listItemArr), // 空list处理
                    });
                } else {
                    let bulletListItemDeal2Result =
                        bulletListItemDeal2(listItemArr);
                    listArr.push({
                        type: "taskItem",
                        attrs: {
                            checked:
                                bulletListItemDeal2Result?.[0]?.attrs?.checked === true
                                    ? true
                                    : false,
                        },
                        content:
                            bulletListItemDeal2Result.length === 0
                                ? [
                                    {
                                        type: "paragraph",
                                        content: [{ type: "text", text: " " }],
                                    },
                                ]
                                : bulletListItemDeal2Result, // 空list处理
                    });
                }
                listItemArr = [];
                startCompute = false;
            } else if (startCompute) {
                listItemArr.push(nestArr[i]);
            }
        }

        bulletList = ifBullet
            ? {
                type: "bulletList",
                content: listArr,
            }
            : {
                type: "taskList",
                content: listArr,
            };
        return bulletList;
    }

    // 专门处理最外层list-item 需要注意的是这个时候listitem里面可能只有最基本的item结构，也有可能嵌套着list
    function bulletListItemDeal2(nestArr: any[]) {
        let listArr = [];
        let listItemArr: any[] = [];
        let insideBulletList = false;
        let insideNumberList = false;
        for (let i = 0; i < nestArr.length; i++) {
            if (nestArr[i].type === "bullet_list_open") {
                listItemArr.push(nestArr[i]);
                insideBulletList = true;
            } else if (
                nestArr[i].type === "bullet_list_close" &&
                countCharacterInArray(
                    `bullet_list_open`,
                    nestArr.slice(0, i + 1)
                ) ===
                countCharacterInArray(
                    `bullet_list_close`,
                    nestArr.slice(0, i + 1)
                ) &&
                checkFirstTagClose(nestArr.slice(0, i + 1))
            ) {
                listItemArr.push(nestArr[i]);
                insideBulletList = false;
                // 如果 listArr 为空，先添加一个空的 paragraph
                // 因为 listItem 的第一个子节点必须是 paragraph
                if (listArr.length === 0) {
                    listArr.push({
                        type: "paragraph",
                        content: [{ type: "text", text: " " }],
                    });
                }
                listArr.push(bulletListItemDeal1(listItemArr));
                listItemArr = [];
            } else if (nestArr[i].type === "ordered_list_open") {
                listItemArr.push(nestArr[i]);
                insideNumberList = true;
            } else if (
                nestArr[i].type === "ordered_list_close" &&
                countCharacterInArray(
                    `ordered_list_open`,
                    nestArr.slice(0, i + 1)
                ) ===
                countCharacterInArray(
                    `ordered_list_close`,
                    nestArr.slice(0, i + 1)
                ) &&
                checkFirstTagClose(nestArr.slice(0, i + 1))
            ) {
                listItemArr.push(nestArr[i]);
                insideNumberList = false;
                // 如果 listArr 为空，先添加一个空的 paragraph
                // 因为 listItem 的第一个子节点必须是 paragraph
                if (listArr.length === 0) {
                    listArr.push({
                        type: "paragraph",
                        content: [{ type: "text", text: " " }],
                    });
                }
                listArr.push(numberListItemDeal1(listItemArr));
                listItemArr = [];
            } else if (insideBulletList || insideNumberList) {
                listItemArr.push(nestArr[i]);
            } else if (
                nestArr[i].type === "inline" &&
                !insideBulletList &&
                !insideNumberList
            ) {
                if (nestArr[i].content.startsWith("[ ] ")) {
                    listArr.push({
                        type: "paragraph",
                        content: markControl(
                            nestArr[i].content.replace(/^\[\s]\s/i, "")
                        ).map((node) => node.toJSON()),
                    });
                } else if (nestArr[i].content.startsWith("[x] ")) {
                    listArr.push({
                        type: "paragraph",
                        attrs: { checked: true },
                        content: markControl(
                            nestArr[i].content.replace(/^\[x\]\s/i, "")
                        ).map((node) => node.toJSON()),
                    });
                } else {
                    listArr.push({
                        type: "paragraph",
                        content: markControl(nestArr[i].content).map((node) =>
                            node.toJSON()
                        ),
                    });
                }
            }else if (
                nestArr[i].type === "fence" &&
                !insideBulletList &&
                !insideNumberList
            ) {
                // 处理list_item内部的代码块
                listArr.push({
                    type: "codeBlock",
                    content: [
                        {
                            type: "text",
                            text:
                                nestArr[i].content === ""
                                    ? " "
                                    : nestArr[i].content,
                        },
                    ],
                });
            }
        }
        if (listArr.length === 0) {
            listArr.push({
                type: "paragraph",
                content: [{ type: "text", text: " " }],
            });
        }
        return listArr;
    }

    //判断是bullet还是tasklist的探针
    function bulletListItemDetect2(nestArr: any[]) {
        let ifBullet = true // 是bullet还是task
        let listArr = []
        let listItemArr: any[] = []
        let insideBulletList = false;
        let insideNumberList = false;
        for (let i = 0; i < nestArr.length; i++) {
            if (nestArr[i].type === "bullet_list_open") {
                listItemArr.push(nestArr[i])
                insideBulletList = true;
            } else if (nestArr[i].type === "bullet_list_close" && countCharacterInArray(`bullet_list_open`, nestArr.slice(0, i + 1)) === countCharacterInArray(`bullet_list_close`, nestArr.slice(0, i + 1))) {
                listItemArr.push(nestArr[i])
                insideBulletList = false;
                listArr.push(bulletListItemDeal1(listItemArr))
                listItemArr = [];
            } else if (nestArr[i].type === "ordered_list_open") {
                listItemArr.push(nestArr[i])
                insideNumberList = true;
            } else if (nestArr[i].type === "ordered_list_close" && countCharacterInArray(`ordered_list_open`, nestArr.slice(0, i + 1)) === countCharacterInArray(`ordered_list_close`, nestArr.slice(0, i + 1))) {
                listItemArr.push(nestArr[i])
                insideNumberList = false;
                listArr.push(numberListItemDeal1(listItemArr))
                listItemArr = [];
            } else if (insideBulletList || insideNumberList) {
                listItemArr.push(nestArr[i])
            } else if (nestArr[i].type === "inline" && !insideBulletList && !insideNumberList) {
                if (nestArr[i].content.startsWith('[ ] ')) {
                    listArr.push({ type: 'paragraph', content: [{ type: 'text', text: nestArr[i].content.replace(/^\[\s]\s/i, "") }] });
                    ifBullet = false
                } else if (nestArr[i].content.startsWith('[x] ')) {
                    listArr.push({ type: 'paragraph',attrs: { checked: true }, content: [{ type: 'text', text: nestArr[i].content.replace(/^\[x\]\s/i, "") }] });
                    ifBullet = false
                } else {
                    listArr.push({ type: 'paragraph', content: [{ type: 'text', text: nestArr[i].content }] });
                    ifBullet = true
                }
            }
        }
        return ifBullet;
    }
    function bulletListDealJson(nestArr: any[]) {
        // let listArr: any[] = []
        // let listItemArr: any[] = []
        // let startCompute = false
        // 第一步需要判断是bullet还是task

        return bulletListItemDeal1(nestArr)

        // 判断是bullet还是task
        // let bulletListBlock: any[] = [];
        // let insideBulletList = false;
        // let currentListItem: any = null
        // let ifBullet = true


        // nestArr.forEach(item => {
        //   if (item.type === "list_item_open" && !insideBulletList) {
        //     // 开始一个新的 list_item
        //     currentListItem = { type: "listItem", content: [] };
        //   } else if (item.type === "list_item_close" && !insideBulletList) {
        //     // 结束一个 list_item，将其加入结果数组
        //     if (currentListItem) {
        //       listArr.push(currentListItem);
        //       currentListItem = null;
        //     }
        //   } else if (item.type === "bullet_list_open" && currentListItem) {
        //     insideBulletList = true;
        //     bulletListBlock.push(item);
        //   } else if (item.type === "bullet_list_close" && currentListItem) {
        //     // 结束 bullet_list
        //     bulletListBlock.push(item);
        //     if (currentListItem) {
        //       // 将 bullet_list 块封装成数组并加入当前 list_item
        //       currentListItem.content.push(bulletListDealJson(bulletListBlock));
        //     }
        //     bulletListBlock = [];
        //     insideBulletList = false;
        //   } else if (insideBulletList && currentListItem) {
        //     bulletListBlock.push(item);
        //   } else {
        //     if (currentListItem && item.type === "inline") {
        //       if (item.content.startsWith('[ ] ')) {
        //         currentListItem.content.push({ type: 'paragraph', content: [{ type: 'text', text: item.content.replace(/^\[\s]\s/i, "") }] });
        //         currentListItem.type = 'taskItem'
        //         ifBullet = false;
        //       } else if (item.content.startsWith('[x] ')) {
        //         currentListItem.content.push({ type: 'paragraph', content: [{ type: 'text', text: item.content.replace(/^\[x\]\s/i, "") }] });
        //         currentListItem.type = 'taskItem'
        //         currentListItem.attrs = { checked: true }
        //         ifBullet = false;
        //       } else {
        //         currentListItem.content.push({ type: 'paragraph', content: [{ type: 'text', text: item.content }] });
        //         currentListItem.type = 'listItem'
        //         ifBullet = true;
        //       }
        //     }
        //   }
        // })

        // nestArr.forEach(item => {
        //   if (item.type === "list_item_open" && !insideBulletList) {
        //     // 开始一个新的 list_item
        //     currentListItem = { type: "listItem", content: [] };
        //   } else if (item.type === "list_item_close" && !insideBulletList) {
        //     // 结束一个 list_item，将其加入结果数组
        //     if (currentListItem) {
        //       listArr.push(currentListItem);
        //       currentListItem = null;
        //     }
        //   } else if (item.type === "bullet_list_open" && currentListItem) {
        //     insideBulletList = true;
        //     bulletListBlock.push(item);
        //   } else if (item.type === "bullet_list_close" && currentListItem) {
        //     // 结束 bullet_list
        //     bulletListBlock.push(item);
        //     if (currentListItem) {
        //       // 将 bullet_list 块封装成数组并加入当前 list_item
        //       currentListItem.content.push(bulletListDealJson(bulletListBlock));
        //     }
        //     bulletListBlock = [];
        //     insideBulletList = false;
        //   } else if (insideBulletList && currentListItem) {
        //     bulletListBlock.push(item);
        //   } else {
        //     if (currentListItem && item.type === "inline") {
        //       if (item.content.startsWith('[ ] ')) {
        //         currentListItem.content.push({ type: 'paragraph', content: [{ type: 'text', text: item.content.replace(/^\[\s]\s/i, "") }] });
        //         currentListItem.type = 'taskItem'
        //         ifBullet = false;
        //       } else if (item.content.startsWith('[x] ')) {
        //         currentListItem.content.push({ type: 'paragraph', content: [{ type: 'text', text: item.content.replace(/^\[x\]\s/i, "") }] });
        //         currentListItem.type = 'taskItem'
        //         currentListItem.attrs = { checked: true }
        //         ifBullet = false;
        //       } else {
        //         currentListItem.content.push({ type: 'paragraph', content: [{ type: 'text', text: item.content }] });
        //         currentListItem.type = 'listItem'
        //         ifBullet = true;
        //       }
        //     }
        //   }
        // })

        // const ListJSON = ifBullet ? {
        //   type: 'bulletList',
        //   content: listArr
        // } : {
        //   type: 'taskList',
        //   content: listArr
        // };
        // console.log('---bullet-list--json--', ListJSON);

        // return ListJSON;
    }


    // paragraph处理
    function paragraphDeal(content: string, returnNodes = false) {
        let lastIndex = 0;
        let match;
        // 对链接进行处理
        const linkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
        const nodes = [];

        while ((match = linkRegex.exec(content)) !== null) {
            const [fullMatch, linkText, linkUrl] = match;
            // 添加链接标记前的纯文本节点
            if (match.index > lastIndex) {
                // nodes.push(schema.text(content.slice(lastIndex, match.index)));
                nodes.push(...markControl(content.slice(lastIndex, match.index)));
            }

            const linkMark = schema.marks.link.create({ href: linkUrl });
            const linkNode = schema.text(linkText).mark([linkMark]);
            nodes.push(linkNode);
            lastIndex = match.index + fullMatch.length;
        }
        if (lastIndex < content.length) {
            // nodes.push(schema.text(content.slice(lastIndex)));
            nodes.push(...markControl(content.slice(lastIndex)));
        }
        return returnNodes
            ? nodes
            : schema.nodes.paragraph.create(null, nodes);
    }

    function processEmptyParagraphs(arr) {
        let consecutiveEmptyCount = 0; // 记录连续空行数量
        const result = []; // 结果数组，用于存放处理后的数据
        const emptyParagraphs = []; // 用于临时存放空行的索引

        for (let i = 0; i < arr.length; i++) {
            const item = arr[i];

            // 检查当前项是否为空行 (type为paragraph且content为空)
            if (
                item?.type?.name === "paragraph" &&
                item?.textContent === "" &&
                item?.content?.size === 0
            ) {
                emptyParagraphs.push(i); // 将空行的索引添加到临时数组
                consecutiveEmptyCount++; // 增加空行计数
            } else {
                // 处理空行，连续空行的数量大于2时，做删除处理
                if (consecutiveEmptyCount > 0) {
                    if (consecutiveEmptyCount <= 2) {
                        // 如果连续空行小于等于2，直接删除
                        for (let j = 0; j < emptyParagraphs.length; j++) {
                            result.splice(emptyParagraphs[j] - j, 1); // 删除空行
                        }
                    } else {
                        // 如果连续空行大于2，减去2然后向上取整
                        const toDelete = Math.ceil((consecutiveEmptyCount - 2) / 2);
                        for (let j = 0; j < toDelete; j++) {
                            result.splice(emptyParagraphs[j] - j, 1); // 删除多余的空行
                        }
                    }
                    consecutiveEmptyCount = 0; // 重置连续空行计数
                    emptyParagraphs.length = 0; // 清空临时存放空行索引的数组
                }
                result.push(item); // 非空行，直接加入结果
            }
        }

        // 如果最后有空行需要删除，也要处理
        if (consecutiveEmptyCount > 0) {
            if (consecutiveEmptyCount <= 2) {
                for (let j = 0; j < emptyParagraphs.length; j++) {
                    result.splice(emptyParagraphs[j] - j, 1); // 删除空行
                }
            } else {
                const toDelete = Math.ceil((consecutiveEmptyCount - 2) / 2);
                for (let j = 0; j < toDelete; j++) {
                    result.splice(emptyParagraphs[j] - j, 1); // 删除多余的空行
                }
            }
        }

        return result;
    }

    function countCharacterInArray(char: string, arr: any[]) {
        return arr.reduce((total, str) => {
            return total + (str.type === char ? 1 : 0);
        }, 0);
    };

    function computeFinal(nodeType: string, nodeArr: any[]) {
        return countCharacterInArray(`${nodeType}_open`, nodeArr) === countCharacterInArray(`${nodeType}_close`, nodeArr)
    }

    // blockquote处理：支持内部嵌套段落、bullet_list、ordered_list等
    function blockquoteDeal(nestArr: any[]) {
        const innerTokens = nestArr.slice(1, nestArr.length - 1); // 去掉外层blockquote_open和blockquote_close
        const blockquoteChildren: any[] = [];
        let tempArr: any[] = [];
        let depth = 0; // 追踪嵌套深度

        for (let i = 0; i < innerTokens.length; i++) {
            const token = innerTokens[i];

            if (depth === 0) {
                if (token.type === "paragraph_open") {
                    tempArr.push(token);
                    depth = 0;
                    let j = i + 1;
                    while (j < innerTokens.length && innerTokens[j].type !== "paragraph_close") {
                        tempArr.push(innerTokens[j]);
                        j++;
                    }
                    if (j < innerTokens.length) {
                        tempArr.push(innerTokens[j]); // paragraph_close
                    }
                    // 处理收集到的paragraph tokens
                    const inlineToken = tempArr.find((t: any) => t.type === "inline");
                    if (inlineToken) {
                        const content = inlineToken.content;
                        const paragraphs = content
                            .split("\n")
                            .map((line: string) =>
                                schema.nodes.paragraph.create(
                                    null,
                                    line ? markControl(line) : null
                                )
                            );
                        blockquoteChildren.push(...paragraphs);
                    } else {
                        blockquoteChildren.push(
                            schema.nodes.paragraph.create(null, null)
                        );
                    }
                    i = j; // 跳过已处理的tokens
                    tempArr = [];
                } else if (token.type === "bullet_list_open") {
                    tempArr.push(token);
                    depth = 1;
                } else if (token.type === "ordered_list_open") {
                    tempArr.push(token);
                    depth = 1;
                } else if (token.type === "blockquote_open") {
                    tempArr.push(token);
                    depth = 1;
                } else if (token.type === "heading_open") {
                    tempArr.push(token);
                    // 收集直到heading_close
                    let j = i + 1;
                    while (j < innerTokens.length && innerTokens[j].type !== "heading_close") {
                        tempArr.push(innerTokens[j]);
                        j++;
                    }
                    if (j < innerTokens.length) {
                        tempArr.push(innerTokens[j]);
                    }
                    const headingNode = nestDeal(tempArr);
                    if (headingNode) {
                        blockquoteChildren.push(headingNode);
                    }
                    i = j;
                    tempArr = [];
                } else if (token.type === "fence") {
                    const fenceNode = nestDeal([token]);
                    if (fenceNode) {
                        blockquoteChildren.push(fenceNode);
                    }
                } else if (token.type === "hr") {
                    const hrNode = nestDeal([token]);
                    if (hrNode) {
                        blockquoteChildren.push(hrNode);
                    }
                }
            } else {
                // 嵌套中，收集tokens并追踪depth
                tempArr.push(token);

                if (
                    token.type === "bullet_list_open" ||
                    token.type === "ordered_list_open" ||
                    token.type === "blockquote_open"
                ) {
                    depth++;
                } else if (
                    token.type === "bullet_list_close" ||
                    token.type === "ordered_list_close" ||
                    token.type === "blockquote_close"
                ) {
                    depth--;
                    if (depth === 0) {
                        // 嵌套结构闭合，处理tempArr
                        const firstType = removeLastUnderscoreSuffix(tempArr[0].type);
                        if (firstType === "bullet_list") {
                            const listNode = bulletListDeal(tempArr);
                            if (listNode) {
                                blockquoteChildren.push(listNode);
                            }
                        } else if (firstType === "ordered_list") {
                            const listNode = numberListDeal(tempArr);
                            if (listNode) {
                                blockquoteChildren.push(listNode);
                            }
                        } else if (firstType === "blockquote") {
                            const bqNode = blockquoteDeal(tempArr);
                            if (bqNode) {
                                blockquoteChildren.push(bqNode);
                            }
                        }
                        tempArr = [];
                    }
                }
            }
        }

        // 如果blockquote内没有任何子节点，添加一个空段落
        if (blockquoteChildren.length === 0) {
            blockquoteChildren.push(
                schema.nodes.paragraph.create(null, null)
            );
        }

        return schema.nodes.blockquote.create(null, blockquoteChildren);
    }

    // 将markdown-it解析得到的token 转化成 tiptap的node节点
    function nestDeal(nestArr: any[]) {
        console.log('---处理嵌套---', nestArr);

        let finNode
        switch (removeLastUnderscoreSuffix(nestArr[0].type)) {
            case "heading":
                const headingLevel = parseInt(nestArr[0].tag.slice(-1), 10)
                const headingText = nestArr[1].content;
                const uuid = crypto.randomUUID()
                if (headingLevel === 1 && headingText === `<br>`) {
                    finNode = schema.nodes.paragraph.create(null, null)
                } else {
                    finNode = schema.nodes.heading.create({ level: headingLevel,id: uuid }, markControl(headingText));
                }
                break;
            case "paragraph":
                // 对图片链接进行处理（使用全局匹配，支持图片与文本混合）
                const imageRegex = /!\[([^\]]*)\]\(([^)]*)\)/g;
                const imageMatches = [
                    ...nestArr[1].content.matchAll(imageRegex),
                ];
                if (imageMatches.length > 0) {
                    const sections = [];
                    let lastIndex = 0;

                    for (const imageMatch of imageMatches) {
                        // 处理图片前的文本内容
                        if (imageMatch.index > lastIndex) {
                            const textBefore = nestArr[1].content
                                .slice(lastIndex, imageMatch.index)
                                .trim();
                            if (textBefore) {
                                // 按换行分割，每行作为一个段落
                                textBefore.split("\n").forEach((line) => {
                                    if (line.trim()) {
                                        sections.push(paragraphDeal(line));
                                    }
                                });
                            }
                        }

                        // 添加图片节点
                        let imgSrc = imageMatch[2];

                        // 只保留网络图片和已经是 atom:// 协议的图片
                        if (
                            !imgSrc.startsWith("http://") &&
                            !imgSrc.startsWith("https://") &&
                            !imgSrc.startsWith("atom://") &&
                            !imgSrc.startsWith("data:")
                        ) {
                            // 是相对路径的本地图片，跳过不添加
                            lastIndex = imageMatch.index + imageMatch[0].length;
                            continue;
                        }

                        sections.push(
                            schema.nodes.image.create({
                                src: imgSrc,
                                alt: imageMatch[1],
                                title: imageMatch[1],
                            })
                        );

                        lastIndex = imageMatch.index + imageMatch[0].length;
                    }

                    // 处理最后一张图片后的文本内容
                    if (lastIndex < nestArr[1].content.length) {
                        const textAfter = nestArr[1].content
                            .slice(lastIndex)
                            .trim();
                        if (textAfter) {
                            textAfter.split("\n").forEach((line) => {
                                if (line.trim()) {
                                    sections.push(paragraphDeal(line));
                                }
                            });
                        }
                    }

                    finNode = sections.length === 1 ? sections[0] : sections;
                } else {
                    // 对task进行处理
                    const taskRegex = /^\[(x?)\] (.+)$/gm;
                    const sections = [];
                    let currentTasks = [];
                    let lastIndex = 0;
                    let match;

                    while ((match = taskRegex.exec(nestArr[1].content)) !== null) {
                        const isCompleted = match[1] === 'x'; // 判断任务是否完成
                        const taskText = match[2]; // 提取任务内容

                        // 检查非任务内容
                        if (match.index > lastIndex) {
                            const contentBetween = nestArr[1].content.slice(lastIndex, match.index).trim();
                            if (contentBetween) {
                                if (currentTasks.length > 0) {
                                    sections.push(editorRef.current.schema.nodeFromJSON({
                                        type: 'taskList',
                                        content: currentTasks
                                    }));
                                    currentTasks = [];
                                }
                                contentBetween.split('\n').map(pitem => {
                                    sections.push(paragraphDeal(pitem));
                                })
                            }
                        }

                        // 添加任务节点
                        currentTasks.push({
                            type: 'taskItem',
                            attrs: { checked: isCompleted },
                            content: [{ type: 'paragraph', content: [{ type: 'text', text: taskText }] }]
                        });

                        // 更新 lastIndex 位置
                        lastIndex = taskRegex.lastIndex;
                    }

                    // 处理最后一段任务或内容
                    if (currentTasks.length > 0) {
                        sections.push(editor.schema.nodeFromJSON({
                            type: 'taskList',
                            content: currentTasks
                        }));
                    }
                    if (lastIndex < nestArr[1].content.length) {
                        let remainingContent = nestArr[1].content.slice(lastIndex).trim();
                        if (remainingContent) {
                            // 添加第4原则：排除 $WORD 格式的 cashtag（如 $TRUMP, $BTC），这些不是 LaTeX
                            const regex =
                                /\$\$(.*?)\$\$|\$(?![A-Z]{2,})(?!\s)(?!\d+.*?\$\d)(.*?\S?)(?<!\s)\$/gs;
                            let paragraphContent = [];
                            let lastIndex = 0;

                            for (const match of remainingContent.matchAll(regex)) {
                                const matchStart = match.index;
                                const matchEnd = match.index + match[0].length;

                                // 添加前面的普通文本（可能含换行）
                                const plainText = remainingContent.slice(lastIndex, matchStart);
                                const lines = plainText.split('\n');
                                lines.forEach((line, lineIdx) => {
                                    if (line.trim()) {
                                        paragraphContent.push(
                                            schema.text(line.replace(/\[timestamp\]\\:/g, '[timestamp]:'))
                                        );
                                    }
                                    if (lineIdx < lines.length - 1) {
                                        if (paragraphContent.length > 0) {
                                            sections.push(schema.nodes.paragraph.create({}, paragraphContent.slice()));
                                            paragraphContent.length = 0;
                                        } else {
                                            sections.push(schema.nodes.paragraph.create());
                                        }
                                    }
                                });

                                if (match[1] !== undefined) {
                                    if (paragraphContent.length > 0) {
                                        sections.push(schema.nodes.paragraph.create({}, paragraphContent));
                                        paragraphContent = [];
                                    }
                                    sections.push(
                                        // $$...$$ 一律识别为块级公式
                                        schema.nodes.latexBlock.create({metaData: match[1].trim()})
                                    );
                                } else if (match[2] !== undefined) {
                                    paragraphContent.push(
                                        schema.nodes.latexInline.create({metaData: match[2].trim()})
                                    );
                                }

                                lastIndex = matchEnd;
                            }

                            // 添加最后剩余的文本
                            const remaining = remainingContent.slice(lastIndex);
                            const finalLines = remaining.split('\n');
                            finalLines.forEach((line, lineIdx) => {
                                if (line.trim()) {
                                    // 使用 markControl 处理 修饰符 样式
                                    const styledContent = paragraphDeal(
                                        line.replace(/\[timestamp\]\\:/g, "[timestamp]:"),
                                        true
                                    );
                                    paragraphContent.push(...styledContent);
                                }
                                if (lineIdx < finalLines.length - 1) {
                                    if (paragraphContent.length > 0) {
                                        sections.push(schema.nodes.paragraph.create({}, paragraphContent.slice()));
                                        paragraphContent.length = 0;
                                    } else {
                                        sections.push(schema.nodes.paragraph.create());
                                    }
                                }
                            });

                            if (paragraphContent.length > 0) {
                                sections.push(schema.nodes.paragraph.create({}, paragraphContent));
                            }
                        }
                        finNode = sections
                    } else if (lastIndex === nestArr[1].content.length) {
                        finNode = sections;
                    }
                }
                break;
            case "ordered_list":
                finNode = numberListDeal(nestArr)
                break;
            case "bullet_list":
                finNode = bulletListDeal(nestArr)
                break;
            case "blockquote":
                finNode = blockquoteDeal(nestArr);
                break;
            case "fence":
                finNode = schema.nodes.codeBlock.create(
                    null,
                    schema.text(
                        nestArr[0].content === "" ? " " : nestArr[0].content
                    )
                );
                break;
            case "hr":
                finNode = schema.nodes.horizontalRule.create();
                break;
            case "table":
                finNode = tableDeal(nestArr);
                break;
        }
        return finNode
    }

    // table处理
    function tableDeal(nestArr: any[]) {
        // markdown-it 解析 table 的 token 结构:
        // table_open -> thead_open -> tr_open -> th_open -> inline -> th_close -> ... -> tr_close -> thead_close
        //            -> tbody_open -> tr_open -> td_open -> inline -> td_close -> ... -> tr_close -> tbody_close
        //            -> table_close

        const tableRows: any[] = [];
        let currentRow: any[] = [];
        let currentCellType: "tableHeader" | "tableCell" = "tableCell";
        let inThead = false;
        let inRow = false;
        let inCell = false;

        for (let i = 0; i < nestArr.length; i++) {
            const token = nestArr[i];

            switch (token.type) {
                case "thead_open":
                    inThead = true;
                    break;
                case "thead_close":
                    inThead = false;
                    break;
                case "tbody_open":
                    // tbody 开始
                    break;
                case "tbody_close":
                    // tbody 结束
                    break;
                case "tr_open":
                    inRow = true;
                    currentRow = [];
                    break;
                case "tr_close":
                    inRow = false;
                    if (currentRow.length > 0) {
                        tableRows.push({
                            type: "tableRow",
                            content: currentRow,
                        });
                    }
                    currentRow = [];
                    break;
                case "th_open":
                    inCell = true;
                    currentCellType = "tableHeader";
                    break;
                case "th_close":
                    inCell = false;
                    break;
                case "td_open":
                    inCell = true;
                    // 如果在 thead 中，使用 tableHeader，否则使用 tableCell
                    currentCellType = inThead ? "tableHeader" : "tableCell";
                    break;
                case "td_close":
                    inCell = false;
                    break;
                case "inline":
                    if (inCell && inRow) {
                        // 处理单元格内容
                        const cellContent = token.content || "";
                        let paragraphContent;

                        try {
                            paragraphContent = cellContent.trim()
                                ? markControl(cellContent).map((node: any) =>
                                    node.toJSON()
                                )
                                : [{ type: "text", text: " " }];
                        } catch (e) {
                            // 如果 markControl 处理失败，使用纯文本
                            paragraphContent = [
                                { type: "text", text: cellContent || " " },
                            ];
                        }

                        currentRow.push({
                            type: currentCellType,
                            attrs: {
                                colspan: 1,
                                rowspan: 1,
                            },
                            content: [
                                {
                                    type: "paragraph",
                                    content: paragraphContent,
                                },
                            ],
                        });
                    }
                    break;
            }
        }

        // 如果没有解析到任何行，返回空
        if (tableRows.length === 0) {
            return null;
        }

        // 创建 table JSON 结构
        const tableJson = {
            type: "table",
            content: tableRows,
        };

        try {
            // 使用 editor.schema.nodeFromJSON 转换为 ProseMirror 节点
            return editor.schema.nodeFromJSON(tableJson);
        } catch (e) {
            console.error("Failed to create table node:", e);
            return null;
        }
    }

    // 遍历解析结果，将其转换为 ProseMirror 的 Node 嵌套数组
    let structArr: any[] = []
    let nestArr: any[] = []
    parsed.map(token => {
        switch (token.type) {
            case 'heading_open':
                nestArr.push(token);
                break;
            case "paragraph_open":
                nestArr.push(token);
                break;
            case "ordered_list_open":
                nestArr.push(token);
                break;
            case "list_item_open":
                nestArr.push(token);
                break;
            case "bullet_list_open":
                nestArr.push(token);
                break;
            case "blockquote_open":
                nestArr.push(token);
                break;
            case "table_open":
                nestArr.push(token);
                break;
            case "thead_open":
                nestArr.push(token);
                break;
            case "tr_open":
                nestArr.push(token);
                break;
            case "th_open":
                nestArr.push(token);
                break;
            case "tbody_open":
                nestArr.push(token);
                break;
            case "td_open":
                nestArr.push(token);
                break;
            case "inline": // inline必然包括在其他元素中
                nestArr.push(token);
                break;
            case "fence": // fence可能包裹在list里面，需要判断是否在嵌套结构中
                if (nestArr.length > 0) {
                    nestArr.push(token);
                } else {
                    structArr.push(nestDeal([token]));
                }
                break;
            case "hr":
                if (nestArr.length > 0) {
                    nestArr.push(token);
                } else {
                    structArr.push(nestDeal([token]));
                }
                break;
            case 'heading_close':
                nestArr.push(token);
                if (removeLastUnderscoreSuffix(nestArr[0].type) === 'heading') {
                    structArr.push(nestDeal(nestArr));
                    nestArr = []
                }
                break;
            case "paragraph_close":
                nestArr.push(token);
                if (removeLastUnderscoreSuffix(nestArr[0].type) === 'paragraph') {
                    const dealRes = nestDeal(nestArr)
                    if (Array.isArray(dealRes)) {
                        structArr.push(...dealRes)
                    } else {
                        structArr.push(dealRes);
                    }
                    nestArr = []
                }
                break;
            case "ordered_list_close":
                nestArr.push(token);
                if (removeLastUnderscoreSuffix(nestArr[0].type) === 'ordered_list' && computeFinal("ordered_list", nestArr)) {
                    structArr.push(nestDeal(nestArr));
                    nestArr = []
                }
                break;
            case "list_item_close":
                nestArr.push(token);
                break;
            case "bullet_list_close":
                nestArr.push(token);
                if (removeLastUnderscoreSuffix(nestArr[0].type) === 'bullet_list' && computeFinal("bullet_list", nestArr)) {
                    structArr.push(nestDeal(nestArr));
                    nestArr = []
                }
                break;
            case "blockquote_close":
                nestArr.push(token);
                if (
                    removeLastUnderscoreSuffix(nestArr[0].type) ===
                    "blockquote" &&
                    computeFinal("blockquote", nestArr)
                ) {
                    structArr.push(nestDeal(nestArr));
                    nestArr = [];
                }
                break;
            case "table_close":
                nestArr.push(token);
                if (removeLastUnderscoreSuffix(nestArr[0].type) === "table") {
                    const tableNode = nestDeal(nestArr);
                    if (tableNode) {
                        structArr.push(tableNode);
                    }
                    nestArr = [];
                }
                break;
            case "thead_close":
                nestArr.push(token);
                break;
            case "tr_close":
                nestArr.push(token);
                break;
            case "th_close":
                nestArr.push(token);
                break;
            case "tbody_close":
                nestArr.push(token);
                break;
            case "td_close":
                nestArr.push(token);
                break;
        }
    }).filter(Boolean); // 去除空元素

    // 检查最后一个元素是否是 image 节点，如果是则添加一个空的 paragraph
    // 这是因为 ProseMirror 的 Slice 在处理时，如果最后一个节点是 inline 节点（如 image）
    // 且没有后续的 block 节点来"关闭"结构，会导致节点被忽略
    if (structArr.length > 0) {
        const lastNode = structArr[structArr.length - 1];
        if (lastNode && lastNode.type && lastNode.type.name === "image") {
            structArr.push(
                schema.nodes.paragraph.create(null, schema.text(" "))
            );
        }
    }
    const contentFragment = Fragment.fromArray(
        processEmptyParagraphs(structArr)
    );
    const contentSlice = new Slice(contentFragment, 1, 1);
    return contentSlice
}

export function handlePaste(editor,view, event, slice){
    const html = event.clipboardData?.getData("text/html") || "";
    // 检测是否是 Excel 粘贴的表格
    if (
        html.includes("urn:schemas-microsoft-com:office:excel") ||
        (html.includes("urn:schemas-microsoft-com:office:office") &&
            html.includes("<table") &&
            html.includes("</table>") &&
            !html.includes("<p"))
    ) {
        // 解析 Excel HTML 中的表格数据
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        const table = tempDiv.querySelector("table");
        if (!table) return false;

        const rows = table.querySelectorAll("tr");
        if (rows.length === 0) return false;

        // 提取二维数组数据
        const tableData: string[][] = [];
        rows.forEach((row) => {
            const cells = row.querySelectorAll("td, th");
            const rowData: string[] = [];
            cells.forEach((cell) => {
                rowData.push(cell.textContent?.trim() || "");
            });
            if (rowData.length > 0) {
                tableData.push(rowData);
            }
        });

        if (tableData.length === 0) return false;

        const maxCols = Math.max(...tableData.map((row) => row.length));
        // 补齐每行列数
        tableData.forEach((row) => {
            while (row.length < maxCols) {
                row.push("");
            }
        });

        const { state } = view;
        const { selection } = state;
        const { $from } = selection;

        // 检查光标是否在表格内
        let inTable = false;
        let tableNode: any = null;
        let tablePos = 0;
        for (let depth = $from.depth; depth > 0; depth--) {
            const node = $from.node(depth);
            if (node.type.name === "table") {
                inTable = true;
                tableNode = node;
                tablePos = $from.before(depth);
                break;
            }
        }

        if (inTable && tableNode && editor) {
            // 场景1: 光标在表格内 — 填充数据到已有表格，自动扩展行列
            const schema = editor.schema;

            // 找到当前光标所在的行列位置
            let currentRow = 0;
            let currentCol = 0;
            for (let depth = $from.depth; depth > 0; depth--) {
                const node = $from.node(depth);
                if (
                    node.type.name === "tableCell" ||
                    node.type.name === "tableHeader"
                ) {
                    currentCol = $from.index(depth - 1);
                }
                if (node.type.name === "tableRow") {
                    currentRow = $from.index(depth - 1);
                }
            }

            // 计算已有表格的行列数
            const existingRows = tableNode.childCount;
            const existingCols = tableNode.child(0)?.childCount || 0;

            // 需要的总行列数
            const finalRows = Math.max(
                existingRows,
                currentRow + tableData.length
            );
            const finalCols = Math.max(
                existingCols,
                currentCol + maxCols
            );

            // 构建新的表格：保留原数据 + 粘贴数据覆盖 + 扩展
            const newRows: any[] = [];
            for (let r = 0; r < finalRows; r++) {
                const cells: any[] = [];
                for (let c = 0; c < finalCols; c++) {
                    // 判断该 cell 是否在粘贴数据范围内
                    const inPasteRange =
                        r >= currentRow &&
                        r < currentRow + tableData.length &&
                        c >= currentCol &&
                        c < currentCol + maxCols;

                    let cellContent: any;
                    if (inPasteRange) {
                        // 使用粘贴数据
                        const pasteText =
                            tableData[r - currentRow]?.[c - currentCol] || "";
                        cellContent = schema.nodes.paragraph.create(
                            null,
                            pasteText ? schema.text(pasteText) : null
                        );
                    } else if (r < existingRows && c < existingCols) {
                        // 保留原有 cell 内容
                        const existingRow = tableNode.child(r);
                        const existingCell = existingRow.child(c);
                        cellContent = existingCell.content;
                    } else {
                        // 新扩展的空 cell
                        cellContent = schema.nodes.paragraph.create(null, null);
                    }

                    // 第一行使用 tableHeader，其他行使用 tableCell
                    const isHeader = r === 0;
                    const cellType = isHeader
                        ? schema.nodes.tableHeader
                        : schema.nodes.tableCell;

                    // 保留原有 cell 的 attrs（如果存在）
                    let cellAttrs = null;
                    if (r < existingRows && c < existingCols) {
                        const existingRow = tableNode.child(r);
                        const existingCell = existingRow.child(c);
                        cellAttrs = existingCell.attrs;
                    }

                    cells.push(cellType.create(cellAttrs, cellContent));
                }
                newRows.push(schema.nodes.tableRow.create(null, cells));
            }

            // 获取原表格的 attrs
            const tableAttrs = {
                ...tableNode.attrs,
                tableCellNum: finalCols,
            };

            const newTableNode = schema.nodes.table.create(
                tableAttrs,
                newRows
            );

            // 替换整个表格
            const { tr } = state;
            const tableEnd = tablePos + tableNode.nodeSize;
            tr.replaceWith(tablePos, tableEnd, newTableNode);
            view.dispatch(tr);

            return true; // 阻止默认粘贴
        } else if (editor) {
            // 场景2: 光标在空白处 — 创建新表格
            const schema = editor.schema;
            const rows = tableData.map((rowData, rowIdx) => {
                const cells = rowData.map((cellText) => {
                    const cellType =
                        rowIdx === 0
                            ? schema.nodes.tableHeader
                            : schema.nodes.tableCell;
                    return cellType.create(
                        null,
                        schema.nodes.paragraph.create(
                            null,
                            cellText ? schema.text(cellText) : null
                        )
                    );
                });
                return schema.nodes.tableRow.create(null, cells);
            });

            const tableNodeNew = schema.nodes.table.create(
                { tableCellNum: maxCols },
                rows
            );

            const { tr } = state;
            tr.replaceSelectionWith(tableNodeNew);
            view.dispatch(tr);
            return true; // 阻止默认粘贴
        }
    }
    return false; // 非 Excel 表格，继续默认处理
}


function getSelectionPageCoordinates() {
    const selection = window.getSelection();

    if (!selection || selection.rangeCount === 0) return null;

    const range = selection.getRangeAt(0);
    const rect = range.getBoundingClientRect();

    // 把 clientX/clientY 转换为 pageX/pageY（加上滚动偏移）
    const pageX = rect.left + window.scrollX;
    const pageY = rect.top + window.scrollY;

    return { pageX, pageY };
}

function convertPlainToNodes(text) {
    return text;//转换不能乱加，code里面就粘贴不了文本了。。--
    // const paragraphs = text.split('\n'); // 按空行分割段落
    //
    // let txt = '';
    // for (let i=0;i<paragraphs.length;i++){
    //     txt += `<p data-id="${generateUUID2()}">${paragraphs[i]}</p>`
    // }
    // return txt;
}

export function handleTransformPastedText(text, plain, editorView){
    if (text.length > CARD_MAX_PASTE_SIZE){
        //复制的文本内容大于500k
        return '';
    }

    // 获取当前选中的内容
    const { state } = editorView.dom.editor;
    const { from, to } = state.selection;
    const selectedText = state.doc.textBetween(from, to, "");

    // 使用原生URL API识别URL格式
    const isURL = (str) => {
        if (isSupportLink(str))return true;
        try {
            const urlStr =
                str.startsWith("http://") || str.startsWith("https://")
                    ? str
                    : `https://${str}`;
            new URL(urlStr);
            return str.includes(".") && !str.startsWith(".") && !str.includes(' ');
        } catch (e) {
            return false;
        }
    };

    if (isURL(text) && from !== to) {
        // 确保URL有协议
        const fullUrl =
            text.startsWith("http://") || text.startsWith("https://") || isSupportLink(text)
                ? text
                : `https://${text}`;
        // 如果有选中内容，用选中的文字作为链接文本；否则用URL本身
        const linkText = selectedText || text;
        // 插入链接
        editorView.dom.editor.commands.insertContent(
            `<a href='${fullUrl}' target="_blank">${linkText}</a>`
        );
        return "";
    }

    /**
     * youtube菜单
     */
    if (text.startsWith("https://www.youtube.com/watch?v=")) {
        const menus = [
            {
                label: t('Link'),
                key: 'link',
            },
            {
                label: t('Embed'),
                key: 'embed',
            }
        ]
        editorView.dom.editor.commands.insertContent(`<a href='${text}' target="_self">${text}</a>`)
        const pasteCoord = getSelectionPageCoordinates()
        RightMenu.open(pasteCoord.pageX, pasteCoord.pageY, menus).then(async key => {
            if (key === 'embed') {
                const nodePos = editorView.dom.editor.state.selection.from - (text || "")?.length - 1
                editorView.dom.editor
                    .chain()
                    .focus()
                    .command(({ tr }) => {
                        tr.deleteRange(nodePos, nodePos + (text || "")?.length + 1)
                            .replaceWith(
                                nodePos,
                                nodePos,
                                editorView.dom.editor.schema.nodes.youtube.create({
                                    src: text
                                })
                            );
                        tr.setSelection(NodeSelection.create(tr.doc, nodePos));
                        return true;
                    })
                    .run();
            }
        })
        return ''
    }

    // 如果是deeplink或者blocklink
    if ((isDeepLink(text) || isCardBlockDeeplink(text)) && from !== to) {
        const linkText = selectedText || text;
        // 插入链接
        editorView.dom.editor.commands.insertContent(
            `<a href='${text}' target="_blank">${linkText}</a>`
        );
        return "";
    }

    if (insertCopyLinkToCard(text,editorView.dom.editor)){
        plain = true;
        return '';
    }

    if ((isDeepLink(text) ) && !isTranscriptDeeplink(text)) {
        insertDeeplinkToCard(text,editorView,null)
        return '';
    }

    if (text.startsWith('{"type":"excalidraw/clipboard","elements":[{"type":"image"')){
        try{
            const jsonElement = JSON.parse(text);
            const element = jsonElement.elements[0];
            const file = jsonElement.files[element.fileId];
            if (file){
                const szSrc = 'localfile://'+file.id + '.'+ extFromMineType(file.mimeType);
                // editorView.dom.editor.commands.insertContent(`<p><img src="${szSrc}"/></p>`);
                return '';
            }
        }catch (e){

        }
    }

    if (isUrl(text)){
        return text;
    }
    // 使用
    // const nodes = convertPlainToNodes(text);
    // editorView.dom.editor.commands.insertContent(nodes);

    return text;
}


export function handleTransformPastedHTML(html,view,szSufix,callback){
    if (html.indexOf('<pre><code') >= 0){
        return html;
    }
    const szTxt = removeHtmlTags(html);
    if (insertCopyLinkToCard(szTxt,view.dom.editor)){
        return '';
    }

    // console.log('html: ', html);
    imgServer.getImgFromHtml(html,szSufix,callback)
    if (html.substring(0, 200).includes(`xmlns:o="urn:schemas-microsoft-com:office:office`)) {
        // 检测是否是 Excel 表格
        if (
            html.includes("ProgId content=Excel.Sheet") ||
            html.includes("urn:schemas-microsoft-com:office:excel")
        ) {
            // Excel 表格：清洗为标准 table 结构
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = html;
            const table = tempDiv.querySelector("table");
            if (table) {
                // 移除所有 style 属性和 mso-* 相关内容
                const allElements = table.querySelectorAll("*");
                allElements.forEach((el) => {
                    el.removeAttribute("style");
                    el.removeAttribute("class");
                    el.removeAttribute("width");
                    el.removeAttribute("height");
                });
                table.removeAttribute("style");
                table.removeAttribute("border");
                table.removeAttribute("cellpadding");
                table.removeAttribute("cellspacing");
                table.removeAttribute("width");
                // 移除 col 元素（Excel 专有）
                table.querySelectorAll("col").forEach((col) => col.remove());
                // 构建干净的 table HTML
                return table.outerHTML;
            }
        }

        // 对list进行处理
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        const paragraphs = tempDiv.querySelectorAll("p");
        paragraphs.forEach((p) => {
            if (p.innerHTML.includes("supportLists")) {
                p.style.marginLeft = "";
                p.style.textIndent = "";
            }
        });
        return tempDiv.innerHTML
    } else {
        // 根据样式识别豆包复制过来的span，提取里面的md
        {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = html
                .replace(/<!--StartFragment-->/g, "")
                .replace(/<!--EndFragment-->/g, "")
                .trim();
            const hasBlockElements = tempDiv.querySelector("p, h1, h2, h3, h4, h5, h6, ul, ol, blockquote, table, pre");
            const spans = tempDiv.querySelectorAll("span");
            if (!hasBlockElements && spans.length === 1) {
                const span = spans[0] as HTMLElement;
                const style = span.getAttribute("style") || "";
                const isAiToolSpan =
                    /white-space\s*:\s*pre/.test(style) &&
                    (
                        /font-family\s*:[^;]*(?:ui-sans-serif|system-ui)/.test(style) ||
                        /(?:orphans|widows)\s*:\s*\d/.test(style)
                    );
                if (isAiToolSpan) {
                    const rawText = span.textContent || "";
                    const mdTemp = new MarkdownIt();
                    const renderedHtml = mdTemp.render(rawText);
                    return renderedHtml;
                }
            }
        }

        // let ret = html.replace(/\n/g, '<p></p>')
        // 先移除 lark-record-clipboard span（含元数据 JSON，避免误识别公式）
        html = html.replace(/<span\b[^>]*class="lark-record-clipboard"[^>]*>[\s\S]*?<\/span>/g, "");

        let ret = parseHtmlFromPasteTiptap(html);
        // .replace(/font-weight\s*:\s*[^;]+;?/gi,'')

        // setTimeout(()=>{
        //     window.hookATags();
        // },200)
        return ret
    }
}

export function parseHtmlFromPasteTiptapWithDownload(szHtml,szSufix:any = '',callback){
    imgServer.getImgFromHtml(szHtml,szSufix,callback)
    return parseHtmlFromPasteTiptap(szHtml);
}

export function parseHtmlFromPasteTiptap(szHtml){
    let szRet = szHtml
        .replace(/<p\b[^>]*>(.*?)<\/p>/gs, (match) => {
            return match.replace(/(?<!<br\b[^>]*>)\n/g, '<br/>');
        })
        // 行内公式准确性矫正
        .replace(
            /<span\s+data-meta-block-props="([^"]*)"[^>]*>([\s\S]*?<\/span>)<\/span>/g,
            (match, metaProps, innerContent) => {
                try {
                    // 检查是否包含 EQUATION_BLOCK
                    if (
                        !metaProps.includes("EQUATION_BLOCK") ||
                        !metaProps.includes("equation")
                    ) {
                        return match;
                    }

                    // 解析 meta 属性中的 equation 值
                    const equationMatch = metaProps.match(
                        /&quot;equation&quot;:&quot;([^&]+)&quot;/
                    );
                    if (!equationMatch) {
                        return match;
                    }

                    // 去掉公式末尾的 \n
                    const correctEquation = equationMatch[1].replace(/\\n$/, "");

                    // 检查内层是否有 span 包含 $$...$$
                    const hasInnerSpan =
                        /<span[^>]*>[\s\S]*?\$\$[\s\S]*?\$\$[\s\S]*?<\/span>/g.test(
                            innerContent
                        );
                    if (!hasInnerSpan) {
                        return match;
                    }

                    // 替换内层 span 中的 $$...$$ 内容为准确的 equation 值
                    const correctedInnerContent = innerContent.replace(
                        /(<span[^>]*>[\s\S]*?)\$\$([\s\S]*?)\$\$([\s\S]*?<\/span>)/g,
                        (innerMatch, before, oldEquation, after) => {
                            return `${before}$$${correctEquation}$$${after}`;
                        }
                    );

                    return `<span data-meta-block-props="${metaProps}">${correctedInnerContent}</span>`;
                } catch (error) {
                    console.warn("公式矫正失败:", error);
                    return match;
                }
            }
        )
        .replace(/(<li\b[^>]*>)\n+(<p\b[^>]*>)/g, '$1$2')
        .replace(/(<\/p>)\n+(<\/li>)/g, '$1$2')
        .replace(/<li\b[^>]*>(.*?)<\/li>/gs, (match) => {
            return match.replace(/\n/g, '<br/>');
        })
        // 将p中有img的嵌套结构改成div中有img
        .replace(/<p([^>]*)>(?=.*<img.*?>)(.*?)<\/p>/g, '<div$1>$2</div>')
        .replace(/target\=\"\_blank\"/g, 'target="__self"')
        .replace(/(\<\!--StartFragment--\>)(\<h\d)([^\<]+)(\<\/h\d)(.+)/, '$1<h1$3</h1$5')
        .replace(/style\=\"[^\"]+\"/g, str => {
            // 图片限制最大宽度
            let obj: any = str.slice(7, -1).split(';').reduce((a, b) => {
                if (!b) return a
                let [k, v] = b.split(':')
                return {...a, [k.replace(/\s+/g, '')]: v?.replace(/\s+/g, '')}
            }, {})
            if (obj.width) {
                // let w = +obj.width.replace(/px/, '')
                // if (w > 740) {
                //     let rate = 740 / w
                //     obj.width = '740px'
                //     if (obj.height) {
                //         let h = +obj.height.replace(/px/, '')
                //         obj.height = h * rate + 'px'
                //     }
                // }
                obj.width = '100%';//重置为100%
                obj.height = 'auto';
            }else{
                obj.width = '100%'
                obj.height = 'auto';
            }
            return str.slice(0, 7) + Object.entries(obj).reduce((s, [k, v]) => s + k + ':' + v + ';', '') + str.slice(-1)
        })
        /** 推特复制后无法选中 */
        // .replace(/\<\/?span([^\>]+)?\>/g, '')
        .replace(`<p></p><body>`, '<body>')
        .replace(`<p></p><!--StartFragment-->`, '<!--StartFragment-->')
        .replace(`<p></p></body>`, '</body>')
        .replace(`<p></p></html>`, '</html>')
        .replace(
            /<code[^>]*>([\s\S]*?)<\/code>/g,
            (match, codeContent) => {
                const hasHtmlTag = /<\/?[a-z][\s\S]*>/i.test(codeContent);
                // if (hasHtmlTag) {
                const updatedCodeContent = codeContent.replace(/<p><\/p>/g, "<br>");
                return `<code>${updatedCodeContent}</code>`;
                // } else {
                //     return `<span data-inline-code="true" class="inline-code-style">${codeContent}</span>`
                // }
            }
        )
        .replace(/background-color:.*?;/g, '')
        .replace(/background:.*?;/g, '')
        .replace(/color:\s*oklab\([^)]*\)\s*;/g, "")
        .replace(/text-indent:\s*[^;]+;/g, '')
        .replace(/<a\b[^>]*>[\s\S]*?<\/a>/g, (match) => {
            return match.replace(/text-decoration[^;]*;?\s*/g, "");
        })
        .replace(/font-size\s*:\s*[^;]+;?/gi,'')//移除字体大小
        // .replace(/color:.*?;/g,'')
        .replace(/font-family:.*?;/g,'')
        .replace(/<li\b[^>]*>([\s\S]*?)<\/li>/g, (match) => {
            // 删除其中的 <img>
            // 不然li的自我复制解析就会有问题
            const cleanedContent = match.replace(/<img\b[^>]*>/g, '');
            return cleanedContent;
        })
        .replace(/<div\b[^>]*>([\s\S]*?)<\/div>/g, (match) => {
            let cleanedContent = match
                .replace(/\$\$(.+?)\$\$/gs, (_, formula) => {
                    // console.log(formula,'formula');
                    return `<latex-inline data-metaData="${formula}"></latex-inline>`;
                })
                .replace(
                    /\$(?!\s)(?!\d+.*?\$\d)(.*?\S?)(?<!\s)\$/gs,
                    (_, formula) => {
                        return `<latex-inline data-metaData="${formula}"></latex-inline>`;
                    }
                );
            return cleanedContent;
        })
        .replace(/<p\b[^>]*>([\s\S]*?)<\/p>/g, (match) => {
            if (match.includes("<latex-inline")) return match;
            let cleanedContent = match
                .replace(/\$\$(.+?)\$\$/gs, (_, formula) => {
                    return `<latex-inline data-metaData="${formula}"></latex-inline>`;
                })
                .replace(
                    /\$(?!\s)(?!\d+.*?\$\d)(.*?\S?)(?<!\s)\$/gs,
                    (_, formula) => {
                        return `<latex-inline data-metaData="${formula}"></latex-inline>`;
                    }
                );
            return cleanedContent;
        })
        .replace(/<span\b[^>]*>([\s\S]*?)<\/span>/g, (match) => {
            if (
                match.includes("<latex-inline") ||
                match.includes("data-meta-block-props") ||
                match.includes("data-inline-code")
            )
                return match;
            let cleanedContent = match
                .replace(/\$\$(.+?)\$\$/gs, (_, formula) => {
                    return `<latex-inline data-metaData="${formula}"></latex-inline>`;
                })
                .replace(
                    /\$(?!\s)(?!\d+.*?\$\d)(.*?\S?)(?<!\s)\$/gs,
                    (_, formula) => {
                        return `<latex-inline data-metaData="${formula}"></latex-inline>`;
                    }
                );
            return cleanedContent;
        })
        .replace(/<ul\b[^>]*>([\s\S]*?)<\/ul>/g, (match) => {
        // 去除 <br> 标签
        const cleanedContent = match.replace(/<br\b[^>]*>/gi, '');
        return cleanedContent;
    })
        .replace(/<ol\b[^>]*>([\s\S]*?)<\/ol>/g, (match) => {
            // 去除 <br> 标签
            const cleanedContent = match.replace(/<br\b[^>]*>/gi, '');
            return cleanedContent;
        })

    szRet = szRet.replace(/(?:<br\b[^>]*>\s*)+$/gi, '').replace(/(\s*color\s*:\s*[^;]*;?)/gi, '');
        szRet = szRet.replaceAll('&amp;',"&");
        return szRet;
}


function findLastParagraphInList(node) {
    if (node?.lastChild && node?.lastChild.type.name !== 'paragraph') {
        return findLastParagraphInList(node?.lastChild)
    } else if (node?.lastChild && node?.lastChild.type.name === 'paragraph') {
        return node?.lastChild
    }
}

/**
 * 从content中移除指定id的节点
 * @param content
 * @param nodeId
 * @returns
 */
function removeNodeFromContent(content: any, nodeId: any): any {
    if (!Array.isArray(content)) return { newContent: content, removedNodes: [] };

    const newContent = [];
    const removedNodes = [];

    for (const node of content) {
        if (node.attrs && node.attrs.id === nodeId) {
            removedNodes.push(node);
        } else {
            // 处理子节点
            let childRemoved = [];
            if (node.content) {
                const result = removeNodeFromContent(node.content, nodeId);
                node.content = result.newContent;
                childRemoved = result.removedNodes;
            }
            newContent.push(node);
            removedNodes.push(...childRemoved);
        }
    }

    return { newContent, removedNodes };
}

export function handleBackspace(editor:any,titleRef){
    // 取消高亮
    editor.commands.unsetHighlight();
    // setTimeout(()=>{
    //     window.hookATags();
    // },100)

    const { state, view } = editor;
    const { selection } = state;
    const { from, to,$from } = editor.state.selection;
    // const preNode = $from.nodeBefore;
    // console.log(preNode);
    const resolvedPos = editor.state.doc.resolve(from);
    // 获取当前节点
    const currentNode = resolvedPos.node();
    // 获取当前节点的起始位置
    const nodeStart = resolvedPos.start(resolvedPos.depth);
    const parentNode = resolvedPos.node(resolvedPos.depth - 1);
    const grandNode = resolvedPos.node(resolvedPos.depth - 2);
    const grandGrandNode = resolvedPos.node(resolvedPos.depth - 3);
    const grandResolvedPos = editor.state.doc.resolve(resolvedPos.start(resolvedPos.depth - 2));
    const grandResolvedPosFrom = grandResolvedPos.start(grandResolvedPos.depth);
    // const grandResolvedPosTo = grandResolvedPos.end(grandResolvedPos.depth);
    // debugger
    // if (from === to && from === 1) {
    //     const isEmptyParagraph = currentNode.type.name === 'paragraph' && currentNode.content.size === 0;
    //     if (titleRef.current && isEmptyParagraph) {
    //         const tr = state.tr.deleteRange(0, currentNode.nodeSize);
    //         view.dispatch(tr);
    //         const length = titleRef.current.value.length;
    //         titleRef.current.focus();
    //         titleRef.current.setSelectionRange(length, length);
    //     }
    // }
    if (from === to && from === 1) {
        const isEmptyParagraph = currentNode.type.name === 'paragraph' && currentNode.content.size === 0;
        if (titleRef && titleRef.current && isEmptyParagraph) {
            const tr = state.tr.deleteRange(0, currentNode.nodeSize);
            view.dispatch(tr);
            const length = titleRef.current.value.length;
            titleRef.current.focus();
            titleRef.current.setSelectionRange(length, length);
            return true;
        }
    }

    if (currentNode.type.name === 'paragraph' && selection.$from.pos === nodeStart && currentNode.attrs?.indent > 0 && parentNode.type.name !== 'taskItem' && parentNode.type.name !== 'listItem') {
        editor.commands.outdent()
        return true
    } else if (currentNode.type.name === 'paragraph' && (selection.$from.pos === nodeStart) && (parentNode.type.name === 'taskItem' || parentNode.type.name === 'listItem')) {
        // 全选情况下
        if (((selection.to - selection.from) === (grandNode.nodeSize - 6) || (selection.to - selection.from) === (parentNode.nodeSize - 4)) && selection.from !== selection.to) {
            return false;
        }
        const resolvedPos1 = editor.state.doc.resolve(to);
        const currentNode1 = resolvedPos1.node();
        const parentNode1 = resolvedPos1.node(resolvedPos1.depth - 1);
        // 获取当前节点的 from 和 to
        const parentResolvedPos = editor.state.doc.resolve(resolvedPos1.start(resolvedPos1.depth - 1));
        const from3 = parentResolvedPos.start(parentResolvedPos.depth);
        const to3 = parentResolvedPos.end(parentResolvedPos.depth);

        const parentResolvedPos2 = editor.state.doc.resolve(resolvedPos.start(resolvedPos.depth - 1));
        const from4 = parentResolvedPos2.start(parentResolvedPos2.depth);
        const to4 = parentResolvedPos2.end(parentResolvedPos2.depth);
        // 完全选中多行情况下且为嵌套list
        // if (from4 + 1 === from && to3 - 1 === to && (from !== to || (from === to && ['listItem', 'taskItem'].includes(grandGrandNode.type.name)))) {
        if (from4 + 1 === from && to3 - 1 === to && from !== to) {
            // 如果是嵌套list的第一层
            if (from === to && ['listItem', 'taskItem'].includes(grandGrandNode.type.name) && grandResolvedPosFrom + 2 === from) {
                editor.commands.deleteRange({ from: grandResolvedPosFrom - 2, to: from })
                return true;
            }
            editor.commands.deleteRange({ from: from, to: to })
            return true;
        }

        if (['listItem','taskItem'].includes(parentNode.type.name)&& ['orderedList', 'bulletList', 'taskList'].includes(grandNode.type.name)) {
            if (from === to && resolvedPos.depth <= 4 && !(parentNode.content?.content?.length >= 2 && currentNode.attrs.id !== parentNode.content?.content[0].attrs.id)) {
                if (grandNode.type.name === 'bulletList') {
                    editor.chain().focus().toggleBulletList().run()
                } else if (grandNode.type.name === 'orderedList') {
                    editor.chain().focus().toggleOrderedList().run()
                } else if (grandNode.type.name === 'taskList') {
                    editor.chain().focus().toggleTaskList().run()
                }
            }
            else if (from === to && resolvedPos.depth > 4 && parentNode.content?.content.length >= 2 && currentNode.attrs.id === parentNode.content?.content[parentNode.content?.content.length - 1].attrs.id && parentNode.attrs.id === grandNode.content?.content[grandNode.content?.content.length - 1].attrs.id && (grandNode.attrs.id === grandGrandNode.content?.content[grandGrandNode.content?.content.length - 1].attrs.id)) {
                // let outerListNode = resolvedPos1.node(1);
                // const outerListResolvedPos = editor.state.doc.resolve(resolvedPos.start(1));
                // const outerListFrom = outerListResolvedPos.start(outerListResolvedPos.depth);
                // const outerListTo = outerListResolvedPos.end(outerListResolvedPos.depth);
                // let outerListNodeJson = outerListNode.toJSON();
                // let finalResult = removeNodeFromContent(outerListNodeJson.content, currentNode.attrs.id);
                // outerListNodeJson.content = finalResult.newContent;
                // const uuid = crypto.randomUUID();
                // const fragment = Fragment.fromArray([editor.schema.nodeFromJSON(outerListNodeJson), editor.schema.nodeFromJSON({
                //     type: 'paragraph',
                //     attrs: { id: uuid },
                //     content: (finalResult.removedNodes.length > 0 && finalResult.removedNodes[0]?.content) ? [
                //         {
                //             type: 'text',
                //             text: finalResult.removedNodes[0].content[0].text,
                //         },
                //     ] : [], // 空内容
                // })]);
                // const slice = new Slice(fragment, 0, 0);
                // const newtr = state.tr.replaceRange(outerListFrom, outerListTo, slice);
                // view.dispatch(newtr)
                // setTimeout(() => {
                //     const selectNodeNP = editor.$doc.querySelectorAll('paragraph', { id: uuid })[0]
                //     editor.commands.focus(selectNodeNP.from)
                // }, 0);
                return false;
            }
            else {
                return false
            }
        }
        return true
    }
    else {
        try {
            const { state, view } = editor;
            const { dispatch } = view;
            const { doc } = state;
            // 合并两个numberList
            const lastNodePos = from - 2;
            const nextNodePos = from + 2;

            let lastNodeResolved;
            let nextNodeResolved;
            try {
                lastNodeResolved = doc.resolve(lastNodePos);
            } catch (error) {
                lastNodeResolved = undefined
            }
            try {
                nextNodeResolved = doc.resolve(nextNodePos);
            } catch (error) {
                nextNodeResolved = undefined
            }

            const lastNode = lastNodeResolved?.node();
            const nextNode = nextNodeResolved?.node();
            if (lastNode?.type.name === 'orderedList' && nextNode?.type.name === 'orderedList') {
                const tr = state.tr;

                const nextNodeStart = nextNodeResolved?.start();

                nextNode?.content?.content.forEach((child: Node, offset: number) => {
                    tr.insert(from - 4, child);
                });
                tr.delete(nextNodeStart - 1, nextNodeStart + nextNode.nodeSize);

                if (dispatch) {
                    dispatch(tr);
                    setTimeout(() => {
                        editor.commands.focus(editor.state.selection.from - 4)
                    }, 20);
                }
            }
            if (from !== to && (lastNode?.type.name === 'orderedList' || lastNode?.type.name === 'bulletList' || lastNode?.type.name === 'taskList')) {
                editor.commands.deleteRange({ from: selection.from, to: selection.to })
            }

            // 第一级listitem变为普通内容后的backspace
            if (from === to && currentNode.type.name === 'paragraph' && (lastNode?.type.name === 'orderedList' || lastNode?.type.name === 'bulletList' || lastNode?.type.name === 'taskList')) {
                const lastParagraphInList = findLastParagraphInList(lastNode)
                const selectNodeNP = editor.$doc.querySelectorAll(lastParagraphInList.type.name, { id: lastParagraphInList.attrs.id })[0]
                const tr = state.tr.delete(lastNodeResolved?.end(), nodeStart + currentNode.nodeSize - 1);
                if (currentNode.textContent) {
                    tr.insertText(
                        currentNode.textContent,
                        selectNodeNP?.to - 1, // +1 是 <paragraph> 开头
                    );
                }

                if (dispatch) {
                    dispatch(tr);
                    setTimeout(() => {
                        // 聚焦到最上面list的末尾位置
                        editor.chain().setTextSelection(selectNodeNP.to - 1).focus().run();
                    }, 20);
                    return true
                }
            }
        } catch (e) {
        }

        return false;
    }
}

export function handleTab(editor:any){
    const { state, view } = editor;
    const { selection, doc } = state;
    const { from, to } = selection;
    const { dispatch } = view;
    const resolvedPos = editor.state.doc.resolve(from);
    const tr = state.tr;
    // debugger
    // 获取当前节点
    const currentNode = resolvedPos.node();
    // 获取当前节点的起始位置
    const nodeStart = resolvedPos.start(resolvedPos.depth);
    const parentNode = resolvedPos.node(resolvedPos.depth - 1);
    const grandNode = resolvedPos.node(resolvedPos.depth - 2);
    let lastNodePos
    if (currentNode.type.name === 'paragraph' && (parentNode.type.name === 'listItem' || parentNode.type.name === 'taskItem') && resolvedPos.depth <= 4) {
        lastNodePos = editor.state.doc.resolve(resolvedPos.start(resolvedPos.depth - 2)).pos - 2
    }
    // const
    // 合并两个numberList

    let lastNodeResolved;
    try {
        lastNodeResolved = doc.resolve(lastNodePos);
    } catch (error) {
        lastNodeResolved = undefined
    }

    const lastNode = lastNodeResolved?.node();

    // 禁止在第一个listitem中使用tab后的默认行为 不限深度  但是如果上一个node是list且当前深度为第一层级放行
    if (currentNode.type.name === 'paragraph' && ['listItem', 'taskItem'].includes(parentNode.type.name) && ['bulletList', 'orderedList', 'taskList'].includes(grandNode.type.name) && grandNode.content.content[0].attrs.id === parentNode.attrs.id && !(resolvedPos.depth <= 4 && lastNode && ['bulletList', 'orderedList', 'taskList'].includes(lastNode.type.name))) {
        return true;
    }

    try {
        if (currentNode.type.name === 'paragraph' && (parentNode.type.name === 'listItem' || parentNode.type.name === 'taskItem') && parentNode.attrs.id === grandNode.content.content[0].attrs.id && resolvedPos.depth <= 4 && lastNode && (lastNode.type.name === 'bulletList' || lastNode.type.name === 'orderedList' || lastNode.type.name === 'taskList')) {
            // 结构变更
            const grandNode = resolvedPos.node(resolvedPos.depth - 2);
            const grandResolvedPos = editor.state.doc.resolve(resolvedPos.start(resolvedPos.depth - 2));
            const grandResolvedPosEnd = grandResolvedPos.end(grandResolvedPos.depth);
            const grandResolvedPosStart = grandResolvedPos.start(grandResolvedPos.depth);
            if (grandNode.type.name === lastNode.type.name) {
                return false;
            }
            let lastNodeJson = lastNode.toJSON();
            let lastListitemJson = lastNodeJson.content[lastNodeJson.content.length - 1]?.content

            const lastItemInLastListitem = lastListitemJson[lastListitemJson.length - 1];
            const existingSubList =
                lastItemInLastListitem?.type === grandNode.type.name
                    ? lastItemInLastListitem
                    : lastItemInLastListitem?.type === "bulletList" ||
                    lastItemInLastListitem?.type === "orderedList" ||
                    lastItemInLastListitem?.type === "taskList"
                        ? lastItemInLastListitem
                        : null;

            if (!existingSubList) {
                // 上一个 listItem 末尾没有子列表，直接追加一个新的子列表
                lastListitemJson.push({
                    type: grandNode.type.name,
                    content: [
                        {
                            ...parentNode.toJSON(),
                        },
                    ],
                });
                lastNodeJson.content[
                lastNodeJson.content.length - 1
                    ].content = lastListitemJson;
            } else {
                // 上一个 listItem 末尾已有子列表，将 G2 追加进去
                existingSubList.content = [
                    ...(existingSubList.content || []),
                    {
                        ...parentNode.toJSON(),
                        type: existingSubList.type === "bulletList"
                            ? "listItem"
                            : existingSubList.type === "orderedList"
                                ? "listItem"
                                : "taskItem",
                    },
                ];
                lastNodeJson.content[
                lastNodeJson.content.length - 1
                    ].content = lastListitemJson;
            }

            let changedCurrentNode
            let mixListfragment
            let newtr
            const selectNodeNP = editor.$doc.querySelectorAll(lastNode.type.name, { id: lastNode.attrs.id })[0];
            if (grandNode.content.content.length > 1) {
                let grandNodeJson = grandNode.toJSON();
                grandNodeJson.content = grandNodeJson.content.slice(1);
                changedCurrentNode = editor.schema.nodeFromJSON(grandNodeJson);
                mixListfragment = Fragment.fromArray([editor.schema.nodeFromJSON(lastNodeJson), changedCurrentNode]);
                const mixListSlice = new Slice(mixListfragment, 0, 0);
                newtr = tr.replaceRange(selectNodeNP.pos - 1, grandResolvedPosEnd - 1, mixListSlice);
            }else{
                newtr = tr.replaceRangeWith(selectNodeNP.pos - 1, grandResolvedPosEnd - 1, editor.schema.nodeFromJSON(lastNodeJson));
            }
            dispatch(newtr);
            setTimeout(() => {
                const newSelectNodeNP = editor.$doc.querySelectorAll(currentNode.type.name, { id: currentNode.attrs.id })[0];
                editor.commands.focus(newSelectNodeNP.to)
            },20);
            return true;
        }
        if (parentNode.type.name === 'taskItem') {
            editor.commands.sinkListItem('taskItem');
            return true
        }
    } catch (error) {
        console.log(222, error)
    }
}

export function handleShiftTab(editor:any){
    // 取消高亮
    editor.commands.unsetHighlight();
    const { state, view } = editor;
    const { selection } = state;
    const { from, to } = editor.state.selection;
    const resolvedPos = editor.state.doc.resolve(from);
    // 获取当前节点
    const currentNode = resolvedPos.node();
    // 获取当前节点的起始位置
    const nodeStart = resolvedPos.start(resolvedPos.depth);
    const parentNode = resolvedPos.node(resolvedPos.depth - 1);
    const grandNode = resolvedPos.node(resolvedPos.depth - 2);
    const grandGrandNode = resolvedPos.node(resolvedPos.depth - 3);
    const grandResolvedPos = editor.state.doc.resolve(resolvedPos.start(resolvedPos.depth - 2));
    const grandResolvedPosFrom = grandResolvedPos.start(grandResolvedPos.depth);

    if (currentNode.type.name === 'paragraph' && (parentNode.type.name === 'taskItem' || parentNode.type.name === 'listItem')) {
        //list情况下
        const resolvedPos1 = editor.state.doc.resolve(to);
        const currentNode1 = resolvedPos1.node();
        const parentNode1 = resolvedPos1.node(resolvedPos1.depth - 1);
        // 获取当前节点的 from 和 to
        const parentResolvedPos = editor.state.doc.resolve(resolvedPos1.start(resolvedPos1.depth - 1));
        const from3 = parentResolvedPos.start(parentResolvedPos.depth);
        const to3 = parentResolvedPos.end(parentResolvedPos.depth);

        const parentResolvedPos2 = editor.state.doc.resolve(resolvedPos.start(resolvedPos.depth - 1));
        const from4 = parentResolvedPos2.start(parentResolvedPos2.depth);
        const to4 = parentResolvedPos2.end(parentResolvedPos2.depth);
        if (['listItem', 'taskItem'].includes(parentNode.type.name) && ['orderedList', 'bulletList', 'taskList'].includes(grandNode.type.name)) {
            if (from === to && resolvedPos.depth > 4 && parentNode.content?.content.length >= 2 && currentNode.attrs.id === parentNode.content?.content[parentNode.content?.content.length - 1].attrs.id && parentNode.attrs.id === grandNode.content?.content[grandNode.content?.content.length - 1].attrs.id && (grandNode.attrs.id === grandGrandNode.content?.content[grandGrandNode.content?.content.length - 1].attrs.id)) {
                let outerListNode = resolvedPos1.node(1);
                const outerListResolvedPos = editor.state.doc.resolve(resolvedPos.start(1));
                const outerListFrom = outerListResolvedPos.start(outerListResolvedPos.depth);
                const outerListTo = outerListResolvedPos.end(outerListResolvedPos.depth);
                let outerListNodeJson = outerListNode.toJSON();
                let finalResult = removeNodeFromContent(outerListNodeJson.content, currentNode.attrs.id);
                outerListNodeJson.content = finalResult.newContent;
                const uuid = crypto.randomUUID();
                const fragment = Fragment.fromArray([editor.schema.nodeFromJSON(outerListNodeJson), editor.schema.nodeFromJSON({
                    type: 'paragraph',
                    attrs: { id: uuid },
                    content: (finalResult.removedNodes.length > 0 && finalResult.removedNodes[0]?.content) ? [
                        {
                            type: 'text',
                            text: finalResult.removedNodes[0].content[0].text,
                        },
                    ] : [], // 空内容
                })]);
                const slice = new Slice(fragment, 0, 0);
                const newtr = state.tr.replaceRange(outerListFrom, outerListTo, slice);
                view.dispatch(newtr)
                setTimeout(() => {
                    const selectNodeNP = editor.$doc.querySelectorAll('paragraph', { id: uuid })[0]
                    editor.commands.focus(selectNodeNP.from)
                }, 0);
            }
            else {
                return false
            }
        }
        return true
    }
}